import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Badge20 from '@carbon/icons-react/es/badge/20';
import { useNavigate } from '@rocketlane/rocket-router';
import { Button } from '@rocketlane/ui';
import { Row, Col, Typography } from 'antd';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { SupportedPlansType } from 'api/billing/types';
import { ReactComponent as Diamond } from 'assets/svgs/diamond.svg';
import { Modal as ModalAtom } from 'components/atoms/modal';
import { LinkButton } from 'components/buttons';
import { ROUTE_PATHS } from 'routes/routes-paths';
const Modal = styled(ModalAtom)`
  .ant-modal-body {
    padding: 0;
  }
  padding: 0;
`;
const ModalContentStyled = styled(Row)`
  display: flex;
  flex-direction: row;
  background-color: var(--white-100);
  border-radius: var(--border-radius-small);
  overflow: hidden;
  height: 380px;
`;
const LeftCol = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--coolest-gray-30);
`;
const TypographyText = styled(Typography.Text)``;
const RightCol = styled(Col)`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  width: 104px;
  gap: var(--spacing-03);

  ${TypographyText} {
    font-size: var(--font-size-base);
  }
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--spacing-05);
`;
const UpgradeButton = styled(Button)`
  justify-content: flex-start;
  margin-top: var(--spacing-05);
  margin-bottom: var(--spacing-05);
`;
const ButtonText = styled.span`
  text-align: left;
  flex-grow: 1;
`;
const LearnMoreButton = styled(LinkButton)`
  align-self: flex-start;
`;
const ModalTitle = styled(Typography.Title)`
  font-size: var(--heading-5-size);
  width: 240px;
`;
const ModalDescription = styled(Typography.Text)`
  flex-grow: 1;
  font-size: var(--font-size-base);
  width: 240px;
`;
export const getIcon = (planType)=>{
    if ([
        SupportedPlansType.Enterprise,
        SupportedPlansType['Enterprise-V2']
    ].includes(planType)) {
        return Badge20;
    }
    return Diamond;
};
export const getColor = (planType)=>{
    if ([
        SupportedPlansType.Enterprise,
        SupportedPlansType['Enterprise-V2']
    ].includes(planType)) {
        return 'var(--green-40)';
    }
    return 'var(--warning-border-color)';
};
export const FeatureGatingModal = ({ planType, title, description, featureImage, learnMoreLink })=>{
    const Icon = getIcon(planType);
    const color = getColor(planType);
    const navigate = useNavigate();
    return /*#__PURE__*/ _jsx(Modal, {
        centered: true,
        visible: true,
        width: 824,
        closable: false,
        footer: null,
        children: /*#__PURE__*/ _jsxs(ModalContentStyled, {
            children: [
                /*#__PURE__*/ _jsx(LeftCol, {
                    span: 14,
                    children: /*#__PURE__*/ _jsx("img", {
                        src: featureImage,
                        alt: "Feature Screenshot",
                        style: {
                            width: '80%'
                        }
                    })
                }),
                /*#__PURE__*/ _jsxs(RightCol, {
                    span: 10,
                    children: [
                        /*#__PURE__*/ _jsx(Header, {
                            children: /*#__PURE__*/ _jsxs(HeaderLeft, {
                                children: [
                                    /*#__PURE__*/ _jsx(Icon, {
                                        fill: color,
                                        currentColor: color,
                                        color: color
                                    }),
                                    /*#__PURE__*/ _jsx(TypographyText, {
                                        style: {
                                            color
                                        },
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                            id: `billing.plan.${planType.toLowerCase()}`
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(ModalTitle, {
                            children: title
                        }),
                        /*#__PURE__*/ _jsx(ModalDescription, {
                            children: description
                        }),
                        /*#__PURE__*/ _jsx(UpgradeButton, {
                            variant: "primary",
                            type: "button",
                            rightIcon: /*#__PURE__*/ _jsx(Icon, {
                                fill: "var(--white-100)",
                                color: "var(--white-100)"
                            }),
                            onClick: ()=>navigate(`/${ROUTE_PATHS.SETTINGS}/${ROUTE_PATHS.SETTINGS_BILLING}`),
                            children: /*#__PURE__*/ _jsx(ButtonText, {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: `billing.feature_gating.upgrade_button.${planType.toLowerCase()}`
                                })
                            })
                        }),
                        learnMoreLink && /*#__PURE__*/ _jsx("a", {
                            href: learnMoreLink,
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ _jsx(LearnMoreButton, {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "billing.feature_gating.learn_more"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
